export const NAV_MENU_ID = {
    CREATE_PROPOSAL: 2,
    ACCOUNT_SETTING: 3,
    PROPOSAL_STATUS: 4,
    PROPOSAL_COMPUTATION: 5,
    NEW_ACCOUNT: 6,
    USER_MANAGEMENT: 7,
    PROPOSAL_REQ_EXTENSION: 8,
    CATEGORY_MANAGEMENT: 9,
    REQUEST_AMENDMENT: 10,
    BOOKED_PROPOSAL: 11,
    COMPUTATION_REVIEW: 12,
    COC_COMPLIANCE: 13,
    POLICY_REVIEW: 14,
    APPROVAL_TEAM: 15,
    APPROVAL_MY: 16,
    TRANSFER_OWN: 17,
    EXISTING_GROUP_REQ: 18,
    MY_TEAM: 19,
    GENERAL_CHAT: 20,
    CREATE_RENEWAL: 21,
    PROPOSALS: 22,
} as const;

export const statusStyles: Record<string, string> = {
    Pending: "text-amber-700",
    Rating: "text-violet-700",
    Approved: "text-green-700",
    Release: "text-sky-700",
    Amend: "text-orange-700",
    Booked: "text-teal-700",
    Closed: "text-slate-600",
};
